import { useQuery } from '@tanstack/react-query';
import { scheduleWorkApi } from '../scheduleWorkApi';
import { QueryKey } from '@shared/config';
import { PaginateType } from '@shared/types';

export const useGetScheduleWork = () => {
  return useQuery({
    queryKey: [QueryKey.GET_SCHEDULE_WORK],
    queryFn: () =>
      scheduleWorkApi.getScheduleWorks({
        paginate: PaginateType.NONE,
        filter: {},
      }),
  });
};
